import { Grid } from 'components'
import { quantityIds } from 'config'
import { useEffect, useMemo, useState } from 'react'

import { ConfigurationField } from './configurationField'
import {
  createFieldDisabledState,
  disableAroundFields,
  getFieldsFromExpression,
  getNextField
} from './helpers'
import { getPreviousField } from './helpers/getPreviousField'

type Props = {
  configurations?: {
    id: string
    name: string
    contentType: 'P' | 'L' | 'F'
    dataType: string
    expression: string
    initRange?: number
    endRange?: number
  }[]
  defaultValues?: any
  configurationId?: string
  resetDisableState?: boolean
}

export function ProductConfigurationForm(props: Props) {
  const { configurations, configurationId, resetDisableState } = props
  const [disabledState, setDisabledState] = useState<any>({})

  const fieldsNames = useMemo(
    () => configurations?.map((item) => item.id) || [],
    [configurations]
  )

  const expressionFields = useMemo(() => {
    const a = configurations?.filter((item) => item.expression)
    const b = a?.map((item) => item.expression) || []

    return getFieldsFromExpression(b.join(';'))
  }, [configurations])

  const handleConfigurationFieldChange = (name: string) => {
    const next = getNextField(fieldsNames, name)
    console.log({ next })
    if (!Object.keys(disabledState).length) return undefined
    const nextState = disableAroundFields(
      fieldsNames,
      [], // expressionFields,
      disabledState,
      next
    )
    console.log({ nextState })
    setDisabledState(nextState)
  }

  useEffect(() => {
    setDisabledState(createFieldDisabledState(fieldsNames, quantityIds))
  }, [fieldsNames, resetDisableState, expressionFields])

  return (
    <Grid
      container
      spacing={2}
      item
      style={{ backgroundColor: 'white', zIndex: 99, padding: 16 }}
    >
      {configurations?.map((field) => (
        <Grid item xs={12} key={field.id}>
          <ConfigurationField
            name={field.id}
            contentType={field.contentType}
            dataType={field.dataType}
            expression={field.expression}
            field={field}
            configurationId={configurationId}
            disabled={disabledState?.[field.id]?.disabled}
            onChange={handleConfigurationFieldChange}
            confLength={fieldsNames.length}
            previousField={getPreviousField(fieldsNames, field.id)}
          />
        </Grid>
      ))}
    </Grid>
  )
}
